import { render, staticRenderFns } from "./CustomersView.vue?vue&type=template&id=54215f87&scoped=true&"
import script from "./CustomersView.vue?vue&type=script&lang=js&"
export * from "./CustomersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54215f87",
  null
  
)

export default component.exports